import { useMemo } from "react";
import { useAuth } from "@/auth/AuthProvider";
import { BaseListView } from "@/base";
import { bondTypeLabel } from "@/lib/bondTypeLabel";
import { issuedBondsListView } from "@/pages/issuedBondsListView";

// The Surety nav's Bonds (BRK-S181): the ISSUED bonds across the brokerage.
// Not the orders list, which is its Submissions. A BaseListView page since
// BRK-S253; the definition is `issuedBondsListView`.
export function SuretyBondsPage() {
  const { authedRequest } = useAuth();
  const def = useMemo(
    () => issuedBondsListView({ request: authedRequest, bondTypeLabel }),
    [authedRequest],
  );
  return <BaseListView def={def} />;
}
